import React from 'react'
import ReactDOM from 'react-dom'
import App from './App'
import './index.css'
var paoData = require('./pao.json')

ReactDOM.render(
  <App data={paoData} />,
  document.getElementById('root')
)



// WEBPACK FOOTER //
// ./src/index.js